import React , { useState  } from 'react'


import { Row , Col, Container } from 'react-bootstrap'

function FormEmail() {
  return (
    <>
        <Row>

            <Col className='col-sm-6'>
                <div className="form-group">
                    <label htmlFor="email1">Email:</label>
                    <input type="email" class="form-control" id="email1" aria-describedby="emailHelp" placeholder="Email:"/>
                </div>
            </Col>

            <Col className='col-sm-6'>

                <div className="form-group">
                    <label htmlFor="email2">Email: eMail opcional No 1</label>
                    <input type="email" class="form-control" id="email2" aria-describedby="emailHelp" placeholder="Email:"/>
                </div>

            </Col>

        </Row>

        <Row>


            <Col className='col-sm-6'>

                <div className="form-group">
                    <label htmlFor="email3">Email: eMail opcional No 2</label>
                    <input type="email" class="form-control" id="email3" aria-describedby="emailHelp" placeholder="Email:"/>
                </div>

            </Col>


            <Col className='col-sm-3'>
                <label htmlFor="telefono">Telefono:</label>
                <input type="text" class="form-control m-0 p-1"  
                id="telefono" placeholder="Telefono:"/>
            </Col>


            <Col className='col-sm-3'>
                <label htmlFor="cp">C.P:</label>
                <input type="text" class="form-control m-0 p-1"  
                id="cp" placeholder="C.P:"/>

            </Col>


        </Row>

    </>
  )
}

export default FormEmail